import { render, staticRenderFns } from "./TrxR.vue?vue&type=template&id=7f532858"
import script from "./TrxR.vue?vue&type=script&lang=js"
export * from "./TrxR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports